import { isEmpty, uniqBy } from '~libs.typescript';

import { AdditionalEntitlement, AdditionalEntitlementType, Reimbursement } from '../types';

export const isEntitlementAllowsForReimbursementFree = (additionalEntitlement: AdditionalEntitlement): boolean => {
   switch (additionalEntitlement.additionalEntitlementType) {
      case 'IB':
      case 'IW':
      case 'WE':
      case 'ZK':
         return true;
      default:
         return false;
   }
};

export const isEntitlementRequiredDocumentMissing = (additionalEntitlement: AdditionalEntitlement): boolean => {
   return additionalEntitlement.requiredDocumentMissing;
};

export const isEntitlementRestrictedForReimbursementFreeAndFull = (
   additionalEntitlementType: string
): additionalEntitlementType is 'S' | 'C' | 'DZ' => {
   switch (additionalEntitlementType) {
      case 'S':
      case 'C':
      case 'DZ':
         return true;
      default:
         return false;
   }
};
export const hasAdditionalEntitlementType = (
   additionalEntitlementType: AdditionalEntitlementType,
   additionalEntitlements: AdditionalEntitlement[] | null
): boolean => {
   if (isEmpty(additionalEntitlements)) {
      return false;
   }

   return additionalEntitlements.some(
      (additionalEntitlement) => additionalEntitlement.additionalEntitlementType === additionalEntitlementType
   );
};

type SelectAutomaticSelectionAdditionalEntitlementsParams = {
   additionalEntitlement: AdditionalEntitlement[];
   reimbursement?: Reimbursement;
};

export const selectAutomaticSelectionAdditionalEntitlements = (
   parameters: SelectAutomaticSelectionAdditionalEntitlementsParams
): AdditionalEntitlement[] => {
   const automaticSelectedAdditionalEntitlements = parameters.additionalEntitlement.filter(
      (additionalEntitlement) =>
         additionalEntitlement.automaticSelection && !additionalEntitlement.requiredDocumentMissing
   );

   if (parameters.reimbursement) {
      const foundAdditionalEntitlementsSelectedByUser = parameters.additionalEntitlement.find(
         (additionalEntitlement) => additionalEntitlement.additionalEntitlementType === parameters.reimbursement?.code
      );

      if (foundAdditionalEntitlementsSelectedByUser) {
         automaticSelectedAdditionalEntitlements.push(foundAdditionalEntitlementsSelectedByUser);
      }
   }

   return uniqBy(automaticSelectedAdditionalEntitlements, 'additionalEntitlementType');
};

export const formatAdditionalEntitlements = (
   additionalEntitlementsTypes: AdditionalEntitlementType[]
): string | null => {
   if (isEmpty(additionalEntitlementsTypes)) {
      return null;
   }

   return additionalEntitlementsTypes.join(', ');
};

type SelectAdditionalEntitlementsParameters = {
   additionalEntitlementTypes: AdditionalEntitlementType[];
   additionalEntitlements: AdditionalEntitlement[];
};

export const selectAdditionalEntitlements = (
   parameters: SelectAdditionalEntitlementsParameters
): AdditionalEntitlement[] => {
   const additionalEntitlementTypesSet = new Set(parameters.additionalEntitlementTypes);

   const additionalEntitlements = parameters.additionalEntitlements.filter((additionalEntitlement) => {
      return additionalEntitlementTypesSet.has(additionalEntitlement.additionalEntitlementType);
   });

   return additionalEntitlements;
};

export const mapAdditionalEntitlementsToAdditionalEntitlementsTypes = (
   additionalEntitlements: AdditionalEntitlement[] | null
): AdditionalEntitlementType[] => {
   if (!additionalEntitlements) {
      return [];
   }

   return additionalEntitlements.map(({ additionalEntitlementType }) => additionalEntitlementType);
};
